/**
 * Created by mohameds on 26/6/19.
 */
import React, {Component} from 'react';
import {isEmpty} from 'lodash'
import IndividualPage from "./IndividualPage";
import Slider from './Slider';
import 'react-animated-slider/build/horizontal.css';
import loadingGIF from "../../public/assets/images/loading.gif";
import Header from './common/Header';
import {getUser} from '../../utils/TokenManager';
import {MonitorConst} from  './Constants';
import AgencyNumberPage from  '../../containers/AgencyMonitor/AgencyNumberContainer'
import HappyBirthdayContainer from  '../../containers/AgencyMonitor/HappyBirthdayContainer'
import CoreValueContainer from  '../../containers/AgencyMonitor/CoreValueContainer'
import QuoteContainer from  '../../containers/AgencyMonitor/QuoteContainer';
import DestinationsPageContainer from  '../../containers/AgencyMonitor/DestinationsPageContainer';
import AgencyRevenueContainer from "../../containers/AgencyMonitor/AgencyRevenue";
import RingCentarlContainer from "../../containers/AgencyMonitor/RingCentarlContainer";
import BannerContanier from "../../containers/AgencyMonitor/BannerContanier";
import TopSCorerContainer from "../../containers/AgencyMonitor/TopSCorerContainer";
import AgencyChart from './AgencyChart';


const styles = {
    body: {
        zoom: window.innerHeight / MonitorConst.monitorHeight
    }
};

class MainDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
            content: [],
            timer: 0,
            infinite: true,
            key: 1,
            loading: true,
            scaling: 1,
            userSettings: {
                page_cycle_time: 0,
                show_header: false,
                title: '',
                set_date_as_title: false,
                scaling: 0
            }
        };
        this.bodyClassName = document.body.className;
        this.content = [];
        this.interval = -1;
    }

    componentDidMount = () => {
        /*
        if (window.location.pathname !== '/home') {
            window.location.href = '/home'
        }
        */
        
        if (this.props.agencyLocation) {
            this.setState({loading: true}, () => {
                this.getMonitorHeaderSettings();
            })
        }
        this.setState({loading: true}, () => {
            this.getPagePosition();
            document.addEventListener("keydown", this.handleKeypress, true);
            this.updateDimensions();
            window.addEventListener('resize', this.updateDimensions);
            document.body.className = this.bodyClassName + (this.bodyClassName ? ' ' : '') + 'agencycontainer agency-monitor-container';
            this.applyZoom();
        });
        this.timerHandle = setTimeout(() => {
            if(isEmpty(this.props.agencyMonitor.headerSettings)) {
                window.location.reload(true);
            }
            this.timerHandle = 0;
        }, 15000); 
    };

    componentDidUpdate = (prevProps) => {
        const {agencyLocation, agencyMonitor} = this.props
        if (agencyLocation && agencyLocation !== prevProps.agencyLocation) {
            this.getMonitorHeaderSettings();
        }
        if (agencyMonitor.headerSettings.page_cycle_time && agencyMonitor.pagePositionData.length === 1 && this.interval === -1) {
            this.interval = setInterval(this.pageCall, parseInt(agencyMonitor.headerSettings.page_cycle_time) * 2000)
        }
        if (agencyMonitor.pagePositionData.length > 1 && this.interval !== -1) {
            clearInterval(this.interval)
            this.interval = -1;
        }
    };

    componentWillUnmount() {
        document.body.className = this.bodyClassName;
        for (let i in styles.body) {
            document.body.style[i] = null;
        }
        document.removeEventListener("keydown", this.handleKeypress, false);
        document.removeEventListener("resize", this.updateDimensions, false);
        if (this.timerHandle) {  
            clearTimeout(this.timerHandle);
            this.timerHandle = 0; 
        } 
    }

    handleKeypress = (event) => {
        if (event.keyCode == 122) {
            this.render()
            /*window.location.reload();*/
        }
        if (event.ctrlKey && event.keyCode == 88) {
            this.logout()
        }
    };

    logout = () => {
        this.props.actions.AgencyLocation.logOut();
    };

    updateDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth,
        }, () => {
            this.applyZoom()
        });
    };

    applyZoom = () => {
        let {scaling, userSettings} = this.state;
        if (userSettings.scaling) {
            scaling = userSettings.scaling;
        }

        for (let i in styles.body) {
            document.body.style[i] = (
                (this.state.height / MonitorConst.monitorHeight) * scaling
            )
        }
    };

    getMonitorHeaderSettings = async() => {
        try {
            await this.props.actions.MonitorAdmin.getHeaderSettings(this.props.agencyLocation);
            const scaling = this.props.agencyMonitor.headerSettings.scaling;
            this.setState({loading: false, scaling: scaling});
        } catch (error) {
            console.log(error)
            this.setState({loading: false});
        }
        try {
            
            let settings = await this.props.actions.MonitorAdmin.getMonitorUserSettings(getUser().id);
            if (settings) {
                this.setState({userSettings: settings}, () => this.updateDimensions());
            }
        } catch (error) {
            console.log(error);
        }
    };

    getPagePosition = async() => {
        try {
            let res = await this.props.actions.MonitorPage.getMonitorPageList();
            if (res) {
                this.setState({loading: false})
            }
        }
        catch (error) {
            this.setState({loading: false});
            console.log(error);
        }
    };
    
    getPageInfo = (e) => {
        if (e.slideIndex === this.props.agencyMonitor.pagePositionData.length - 1 == 1) {
            this.setState({loading: true}, () => {
                this.getPagePosition();
                this.getMonitorHeaderSettings();
                this.setState({key: Math.random()});
            })
        }
    };

    pageCall = () => {
        this.getPagePosition();
        this.getMonitorHeaderSettings();
        this.setState({key: Math.random()});
    }

    renderComponent = (pageType, props) => {
        const {userSettings} = this.state;
        const components = {
            [MonitorConst.PAGE_ID.AGENCY_NUMBERS]: <AgencyNumberPage {...props} />,
            [MonitorConst.PAGE_ID.AGENCY_CHART]: <AgencyChart {...props} settings={userSettings} />,
            [MonitorConst.PAGE_ID.DEPARTMENT_NUMBERS]: <AgencyNumberPage {...props} settings={userSettings}/>,
            [MonitorConst.PAGE_ID.INDIVIDUAL_NUMBERS]: <IndividualPage {...props} />,
            [MonitorConst.PAGE_ID.CONGRATULATIONS]: <HappyBirthdayContainer {...props} settings={userSettings} />,
            [MonitorConst.PAGE_ID.CORE_VALUES]: <CoreValueContainer {...props} settings={userSettings}/>,
            [MonitorConst.PAGE_ID.HAPPY_BIRTHDAY]: <HappyBirthdayContainer {...props} settings={userSettings} />,
            [MonitorConst.PAGE_ID.WELCOME_VISITORS]: <HappyBirthdayContainer {...props} settings={userSettings} />,
            [MonitorConst.PAGE_ID.QUOTES]: <QuoteContainer {...props} settings={userSettings} />,
            [MonitorConst.PAGE_ID.DESTINATIONS]: <DestinationsPageContainer {...props} settings={userSettings} />,
            [MonitorConst.PAGE_ID.AGENCY_REVENUE]: <AgencyRevenueContainer {...props} settings={userSettings}/>,
            [MonitorConst.PAGE_ID.RING_CENTRAL]: <RingCentarlContainer {...props} settings={userSettings}/>,
            [MonitorConst.PAGE_ID.BANNER]: <BannerContanier {...props} settings={userSettings}/>,
            [MonitorConst.PAGE_ID.TOP_SCORER]: <TopSCorerContainer {...props} settings={userSettings}/>,
        };
        return components[pageType];
    };

    render() {
        const {agencyMonitor} = this.props;
        const {userSettings} = this.state;
        let pageCycleTime = 5000;

        if (!isEmpty(agencyMonitor.headerSettings)) {
            if (parseInt(userSettings.page_cycle_time)) {
                pageCycleTime = userSettings.page_cycle_time * 1000;
            } else {
                pageCycleTime = agencyMonitor.headerSettings.page_cycle_time * 1000;
            }
        }

        if (!pageCycleTime && !parseInt(pageCycleTime)) {
            pageCycleTime = 5000;
        }
        console.log(userSettings)
        return (
            !isEmpty(agencyMonitor.headerSettings) ?
                <React.Fragment>
                    {userSettings.show_header &&
                        <Header
                            headerSettings={agencyMonitor.headerSettings}
                            totalHeight={this.state.height}
                            userSettings={userSettings}
                        />
                    } 
                    <Slider
                        key={1}
                        autoplay={pageCycleTime}
                        duration={pageCycleTime}
                        infinite={this.state.infinite}
                        onSlideChange={this.getPageInfo}
                    >
                        {
                            agencyMonitor.pagePositionData.map((value, index) => (
                                <div key={index}>
                                    {this.renderComponent(value.monitor_page_type,
                                        {...this.props, pageObj: value, keyValue: this.state.key})
                                    }
                                </div>
                            ))
                        }
                    </Slider>
                </React.Fragment>
            :
            <div className="text-center font-weight-bold font-32 position-relative" 
                style={{top: '38%'}}
            >
                Please Wait...<br/><br/>
                <img src={loadingGIF} alt="loading..." width="64"/>
                <br/>
                <br/>
                If the Page does not load automatically, Then
                <br/>
                <ul>
                    <li>Please check internet connection</li>
                    <li>Refresh the page or Restart the Respberry Pi Device</li>
                </ul>
            </div>
        )
    }

}
export default MainDashboard;



// WEBPACK FOOTER //
// ./src/components/agencyMonitor/MainDashboard.js